// =================================================================
// Store: Strategy slice (PSD §9.1.2 / TODO Task 1.11)
// =================================================================
import type { StateCreator } from 'zustand';
import {
  PKSource,
  PopulationMode,
  Strategy,
  type StrategyConfig,
} from '@/types';
import { DEFAULT_PROTOCOL } from '@/config/defaultProtocol';
import { INFUSION_DEFAULT_MIN } from '@/config/constants';
import type { StoreState, StrategySlice } from './types';

const DEFAULT_STRATEGY: StrategyConfig = {
  strategy: Strategy.ExtendedInterval,
  infusionDurationMin: INFUSION_DEFAULT_MIN,
  infusionStartISO: undefined,
  nomogramSource: DEFAULT_PROTOCOL.defaultNomogram,
  pkSource: PKSource.Population,
  populationMode: PopulationMode.Standard,
};

export const createStrategySlice: StateCreator<StoreState, [], [], StrategySlice> = (set, get) => ({
  strategyConfig: DEFAULT_STRATEGY,
  setStrategy: (s) => {
    set((state) => ({ strategyConfig: { ...state.strategyConfig, strategy: s } }));
    get().scheduleComputeAll();
  },
  setInfusionDuration: (min) => {
    set((state) => ({ strategyConfig: { ...state.strategyConfig, infusionDurationMin: min } }));
    get().scheduleComputeAll();
  },
  setInfusionStart: (iso) => {
    set((state) => ({ strategyConfig: { ...state.strategyConfig, infusionStartISO: iso } }));
    get().scheduleComputeAll();
  },
  setNomogramSource: (src) => {
    set((state) => ({ strategyConfig: { ...state.strategyConfig, nomogramSource: src } }));
    get().scheduleComputeAll();
  },
  setPKSource: (src) => {
    set((state) => ({ strategyConfig: { ...state.strategyConfig, pkSource: src } }));
    get().scheduleComputeAll();
  },
  setPopulationMode: (mode) => {
    set((state) => ({ strategyConfig: { ...state.strategyConfig, populationMode: mode } }));
    get().scheduleComputeAll();
  },
});
